import car42 from '@/assets/img/cartype/car_4_2_box@3x.png'
import car52 from '@/assets/img/cartype/car_5_2_box@3x.png'
import car68 from '@/assets/img/cartype/car_6_8_box@3x.png'
import car76 from '@/assets/img/cartype/car_7_6_box@3x.png'
import car86 from '@/assets/img/cartype/car_8_6_box@3x.png'
import car96 from '@/assets/img/cartype/car_9_6_box@3x.png'
import car125 from '@/assets/img/cartype/car_12_5_box@3x.png'
import car165 from '@/assets/img/cartype/car_16_5_17_5_box@3x.png'
import carcold42 from '@/assets/img/cartype/car_4_2_cold@3x.png'
import carcold52 from '@/assets/img/cartype/car_5_2_cold@3x.png'
import carcold68 from '@/assets/img/cartype/car_6_8_cold@3x.png'
import carcold76 from '@/assets/img/cartype/car_7_6_cold@3x.png'
import carcold86 from '@/assets/img/cartype/car_8_6_cold@3x.png'
import carcold96 from '@/assets/img/cartype/car_9_6_cold@3x.png'
import carcold125 from '@/assets/img/cartype/car_12_5_cold@3x.png'
import carcold137 from '@/assets/img/cartype/car_13_7_cold@3x.png'
import carcold165 from '@/assets/img/cartype/car_15_16_5_cold@3x.png'
import mianbao from '@/assets/img/cartype/car_mianbao@3x.png'
import naiguan from '@/assets/img/cartype/car_naiguan@3x.png'
import yiweike from '@/assets/img/cartype/car_yiweike@3x.png'

export default {
  car42,
  car52,
  car68,
  car76,
  car86,
  car96,
  car125,
  car165,
  carcold42,
  carcold52,
  carcold68,
  carcold76,
  carcold86,
  carcold96,
  carcold125,
  carcold137,
  carcold165,
  mianbao,
  naiguan,
  yiweike,
}